import type Highcharts from 'highcharts';
import type { SeriesStatesOptionsObject } from 'highcharts';
import { formatNumberToCompactNotation } from '../../../utils/renderUtils';

interface IBarChartParams {
    currency: string;
    xAxis: {
        categories: string[];
    };
    series: Highcharts.SeriesOptionsType[];
}

export const getBarChartOptions: (params: IBarChartParams) => Highcharts.Options = (params) => ({
    chart: {
        type: 'column',
        backgroundColor: undefined,
        width: 1000,
        height: 350,
    },
    accessibility: { enabled: false },
    credits: { enabled: false },
    exporting: {
        enabled: false,
    },
    title: { text: '' },
    tooltip: {
        backgroundColor: '#ffffff',
        borderRadius: 4,
        borderWidth: 0,
        formatter: function (this) {
            return `
                <span style="color: var(--fg-color-default-emphasis);
                    font-size: var(--type-label-small-font-size);
                    line-height: var(--type-label-small-line-height);
                    margin-bottom: var(--padding-bottom-md)">
                    ${this.name} ${formatNumberToCompactNotation(this.y)}
                </span>
                <br />
                <span style="color: var(--fg-color-default-normal);
                    font-size: var(--type-body-small-font-size);
                    line-height: var(--type-body-small-line-height);">
                    ${(this.options.weight! * 100).toFixed(0)}%
                </span>`;
        },
    },
    legend: {
        enabled: true,
        verticalAlign: 'bottom',
        squareSymbol: false,
        margin: 32,
        itemMarginTop: 5,
        itemMarginBottom: 10,
        itemDistance: 16,
        symbolHeight: 12,
        symbolWidth: 12,
        symbolPadding: 8,
        itemStyle: {
            color: '#595a5e',
            fontSize: '16px',
            lineHeight: '24px',
        },
    },
    xAxis: {
        categories: params.xAxis.categories,
        gridLineWidth: 0,
        visible: true,
        labels: {
            style: {
                color: '#595a5e',
                fontSize: '20px',
                fontWeight: '400',
            },
        },
    },
    yAxis: {
        reversedStacks: false,
        gridLineWidth: 0,
        visible: false,
        title: {
            enabled: false,
            text: '',
        },
    },
    plotOptions: {
        series: {
            stacking: 'normal',
            events: {
                legendItemClick: () => false,
            },
        },
        bar: {
            borderColor: undefined,
            dataLabels: { enabled: false },
        },
    },
    series: params.series,
});

export const seriesStates: SeriesStatesOptionsObject = {
    hover: {
        opacity: 1,
        brightness: 0,
        halo: null,
    },
    inactive: { opacity: 1 }, // prevent sections from fading out on hover
};
